import { defaultFieldsToRemove } from "@contentful-api/constants/queryFields";
import { deepDelete } from "@contentful-api/helpers/deepDelete";

export const clean = <T>(
    data: T,
    options?: {
        fieldsToRemove?: string[];
    }
) => {
    const { fieldsToRemove = defaultFieldsToRemove } = options || {};

    const cleanData: T = deepDelete(data, fieldsToRemove);

    return cleanData;
};
